// extracted by mini-css-extract-plugin
export default {"root":"ProductVariantsModal_root__IcJQp"};